module.exports = __webpack_public_path__ + "static/img/down.5edab073.svg";